import "@fontsource/noto-sans-jp"
import "@fontsource/noto-serif-jp"
import logo from "./src/images/common/logo.png"

import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

/* ------------------------------
   フェードアニメーション
------------------------------ */

export const onRouteUpdate = () => {
  if ("IntersectionObserver" in window) {
    const elements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeftToRight"
    )

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
      }
    )

    elements.forEach(el => observer.observe(el))
  }
}

/* ------------------------------
   ローディング
------------------------------ */

export const onClientEntry = () => {
  if (typeof document === "undefined") return

  // トップページのみ実行
  if (window.location.pathname !== "/") return

  document.documentElement.classList.add("js")

  const loader = document.createElement("div")
  loader.className = "loader"

  const inner = document.createElement("div")
  inner.className = "loaderInner"

  const catchCopy = document.createElement("p")
  catchCopy.className = "catchCopy"
  catchCopy.innerHTML = `
    モノづくりに携わり、<br>
    皆様の豊かな生活に貢献します。
  `

  const logoImg = document.createElement("img")
  logoImg.src = logo
  logoImg.className = "logo"
  logoImg.alt = "company logo"

  inner.appendChild(catchCopy)
  inner.appendChild(logoImg)
  loader.appendChild(inner)
  document.body.appendChild(loader)

  setTimeout(() => {
    catchCopy.classList.add("show")
  }, 300)

  setTimeout(() => {
    catchCopy.classList.remove("show")
    catchCopy.classList.add("hide")
  }, 2200)

  setTimeout(() => {
    logoImg.classList.add("show")
  }, 2600)

  setTimeout(() => {
    loader.classList.add("hide")
  }, 4500)

  setTimeout(() => {
    loader.remove()
  }, 6000)
}